import { CustomFieldOptionFragment } from '@/gql/graphql'

export class CustomFieldOption {
  public id: string | null
  public value: string
  public displayOrder: number | null

  constructor(
    option: Pick<CustomFieldOptionFragment, 'value'> & Partial<CustomFieldOptionFragment>,
  ) {
    this.id = option.id || null
    this.value = option.value
    this.displayOrder = option.displayOrder || null
  }
}
